import { connect } from 'react-redux';

import {
  toggleSearchResult
} from 'edit/seed-product-selector';

import {
  getActiveSeedProductIds,
  canSelectMoreResults,
  getNumActiveSeedProducts,
  getSearchResults
} from 'edit/seed-product-selector/selectors';

import SeedProductResultsList from './SeedProductResultsList';

export default connect(
  (state) => {
    return {
      activeSeedProductIds: getActiveSeedProductIds(state),
      canSelectMoreResults: canSelectMoreResults(state),
      numActiveSeedProducts: getNumActiveSeedProducts(state),
      searchResults: getSearchResults(state)
    };
  },
  (dispatch) => {
    return {
      onToggleSeedProduct: (productId) => {
        dispatch(toggleSearchResult(productId));
      }
    };
  }
)(SeedProductResultsList);
